import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { ReactComponent as CloseIcon } from '../assets/images/icons/ic-exit.svg';
import { appViewportHeight } from '../helpers/embeddedViewport';

interface PDFViewerProps {
  fileUrl: string;
  title: string;
  onClose?: () => void;
}

export const PDFViewer: React.FC<PDFViewerProps> = ({ fileUrl, title, onClose }) => {
  return (
    <Box height={appViewportHeight(0.9)} width={{ base: '100%', md: appViewportHeight(0.8) }} display="flex" flexDirection="column" background="gray.50">
      <Flex
        padding="16px"
        background="rgba(255, 255, 255, 1)"
        color="rgba(61, 14, 107, 1)"
        border={'1px solid rgba(235, 239, 250, 1)'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Text fontSize="xl" fontWeight="bold">
          {title}
        </Text>
        <Box onClick={onClose} cursor={'pointer'} p="10px">
          <CloseIcon />
        </Box>
      </Flex>
      <Box>
        <iframe
          title="Visualizador de PDF"
          src={fileUrl}
          width="100%"
          height="700px"
          style={{ border: '1px solid #ccc' }}
        />
      </Box>
    </Box>
  );
};
